/**
 * savePlayedAnswer.js
 * Written by: Alex Kasemir
 */

import { setStorage, getStorage } from '@minerva-analytics/pantheon';

export const SAVE_PLAYED_ANSWER_START = `SAVE_PLAYED_ANSWER_START`;
export const SAVE_PLAYED_ANSWER_SUCCESS = `SAVE_PLAYED_ANSWER_SUCCESS`;
export const SAVE_PLAYED_ANSWER_FAILURE = `SAVE_PLAYED_ANSWER_FAILURE`;

export const savePlayedAnswerStart = () => ({
  type: SAVE_PLAYED_ANSWER_START,
});

export const savePlayedAnswerSuccess = (data) => ({
  type: SAVE_PLAYED_ANSWER_SUCCESS,
  data,
});

export const savePlayedAnswerFailure = (error) => ({
  type: SAVE_PLAYED_ANSWER_FAILURE,
  error,
});


/**
 * Description of the savePlayedAnswer action
 */
export const savePlayedAnswer = (data) => {
  return (dispatch) => {
    try {
      let score = parseInt(getStorage({ key: `score` }), 10) || 0;
      let playthroughs = parseInt(getStorage({ key: `playthroughs` }), 10) || 0;
      score += data.score;
      playthroughs += 1;
      setStorage({
        key: `playedAnswer`,
        value: JSON.stringify(data.played_answer),
      });
      setStorage({
        key: `score`,
        value: score.toString(),
      });
      setStorage({
        key: `playthroughs`,
        value: playthroughs.toString(),
      });
      setStorage({
        key: `playedAnswer`,
        value: JSON.stringify(data.played_answer),
        forceCookies: true,
      });
      setStorage({
        key: `score`,
        value: score.toString(),
        forceCookies: true,
      });
      setStorage({
        key: `playthroughs`,
        value: playthroughs.toString(),
        forceCookies: true,
      });
      dispatch(savePlayedAnswerSuccess());
    } catch (error) {
      dispatch(savePlayedAnswerFailure(error));
    }
  };
};

export default savePlayedAnswer;
